<div class="content">
  <router-outlet />
  <app-e-loader />
</div>
